export default {
    login_register: 'Σύνδεση/Εγγραφή',
    booking_confirmation_title: 'Επιβεβαίωση κράτησης',
    booking_confirmation_body: 'Σας ευχαριστούμε για την κράτησή σας. Παρακαλούμε βρείτε τα στοιχεία επιβεβαίωσης παρακάτω.',
    insurance_requirements_modal_disclaimer: `Κάνοντας αυτήν την κράτηση, επιβεβαιώνω ότι: Δεν είχα καταδίκες ή παραβάσεις οδήγησης τα τελευταία 5 χρόνια. Δεν μου έχει απορριφθεί πρόταση, ακυρωθεί συμβόλαιο ή αρνηθεί ανανέωση ή ζητηθεί να πληρώσω αυξημένο ασφάλιστρο ή να επιβληθούν ειδικοί όροι από ασφαλιστική εταιρεία. Δεν έχω αποκλειστεί από την οδήγηση. Δεν εκκρεμεί δίωξη ή αστυνομική έρευνα. Δεν έχω καταδίκες για κλοπή, απάτη ή ανεντιμότητα τα τελευταία 5 χρόνια. Δεν έχω υποφέρει από ελαττωματική όραση ή ακοή (που δεν διορθώνεται με γυαλιά ή ακουστικό), καρδιακή διαταραχή, διαβήτη, επιληψία ή οποιαδήποτε σωματική ή ψυχική ανικανότητα. Δεν είχα ατυχήματα τα τελευταία 5 χρόνια. Πατήστε {0} αν δεν πληροίτε αυτές τις προϋποθέσεις`,
    insurance_requirements_here: 'εδώ',
    insurance_requirements: 'Διάβασα και κατάλαβα τις {0}',
    ir: 'Απαιτήσεις Ασφάλισης',
    location: 'Τοποθεσία',
    pickup_location: 'Τοποθεσία παραλαβής',
    dropoff_location: 'Τοποθεσία παράδοσης',
    vehicle: 'Όχημα',
    pickup_and_dropoff: 'Παραλαβή και Παράδοση (τοπική ώρα)',
    view_voucher: 'Προβολή voucher',
    identity_verification_body: 'Θα χρειαστεί να επαληθεύσετε την ταυτότητά σας πριν παραλάβετε το όχημα',
    identity_verification_title: 'Επαλήθευση ταυτότητας',
    search_again: 'Αναζήτηση ξανά',
    refrigerated: 'ψυγείο',
    aircon_lower: 'κλιματισμός',
    aircon: 'Κλιματισμός',
    refrigeration: 'Ψυγείο',
    not_available: 'Η υπηρεσία Drive & Go είναι διαθέσιμη μόνο για άτομα με έγγραφα ταυτότητας και άδειας οδήγησης από τις παρακάτω χώρες.',
    check_if_included: 'Ελέγξτε αν η χώρα σας περιλαμβάνεται.',
    included_in_booking: 'Περιλαμβάνεται σε αυτή την κράτηση',
    cdw_with_excess: 'CDW με απαλλαγή',
    theft_protection: 'Προστασία κλοπής με απαλλαγή',
    risk_reduction: 'Μείωση κινδύνου',
    free_extras: 'Δικαιούστε δύο δωρεάν επιπλέον <br /> με αυτή την κράτηση.',
    continue: 'Συνέχεια',
    luggage_large_short_label: 'L',
    luggage_medium_short_label: 'M',
    luggage_small_short_label: 'S',
    luggage_large_long_label: 'μεγάλη',
    luggage_medium_long_label: 'μεσαία',
    luggage_small_long_label: 'μικρή',
    fuel_unspecified_label: 'μη καθορισμένο',
    transmission_manual_label: 'Χειροκίνητο',
    transmission_automatic_label: 'Αυτόματο',
    make_a_booking: 'Κάντε κράτηση',
    pickup_date: 'Ημερομηνία παραλαβής',
    dropoff_date: 'Ημερομηνία παράδοσης',
    driver_age: 'Οδηγός μεταξύ 30 - 65',
    enter_driver_age: 'Παρακαλώ εισάγετε την ηλικία του οδηγού',
    promo_code: 'Κωδικός προσφοράς',
    search: 'Αναζήτηση',
    dropoff_date_cannot_be_before_pickup_date: 'Η ημερομηνία παράδοσης δεν μπορεί να είναι πριν την ημερομηνία παραλαβής',
    pickup_date_cannot_be_in_the_past: 'Η ημερομηνία παραλαβής δεν μπορεί να είναι στο παρελθόν',
    pickup_time_cannot_be_in_the_past: 'Η ώρα παραλαβής δεν μπορεί να είναι στο παρελθόν',
    dropoff_time_must_be_later_than_the_pickup_time_if_on_the_same_day: 'Η ώρα παράδοσης πρέπει να είναι αργότερα από την ώρα παραλαβής αν είναι την ίδια μέρα',
    vehicle_filters: 'Φίλτρα οχημάτων',
    reset: 'Επαναφορά',
    transmission: 'Κιβώτιο ταχυτήτων',
    all: 'Όλα',
    manual: 'Χειροκίνητο',
    auto: 'Αυτόματο',
    passengers: 'Επιβάτες',
    vehicle_type: 'Τύπος οχήματος',
    filter: 'Φίλτρο',
    vehicle_search: 'Αναζήτηση οχήματος',
    edit: 'Επεξεργασία',
    no_results: 'Δεν βρέθηκαν αποτελέσματα με τα κριτήρια φίλτρου.',
    small_cars: 'Μικρά αυτοκίνητα',
    medium_cars: 'Μεσαία αυτοκίνητα',
    large_cars: 'Μεγάλα αυτοκίνητα',
    estate_cars: 'Station wagon',
    suvs: 'SUV',
    mpvs: 'MPV',
    vans: 'Βαν',
    camper_vans: 'Camper van',
    premium: 'Premium',
    unspecified: 'μη καθορισμένο',
    large: 'μεγάλο',
    medium: 'μεσαίο',
    small: 'μικρό',
    automatic: 'αυτόματο',
    you_have_been_refunded: 'Έχετε επιστραφεί.',
    please_customer_service: 'Για να κάνετε κράτηση παρακαλούμε επικοινωνήστε με την εξυπηρέτηση πελατών.',
    contact_customer_service: 'Επικοινωνήστε με την εξυπηρέτηση πελατών',
    booking_failed: 'Η κράτησή σας δεν μπόρεσε να ολοκληρωθεί αυτή τη φορά.',
    summary: 'Σύνοψη',
    reforestation_and_protection: 'Υποστηρίξτε την αναδάσωση και προστασία του τροπικού δάσους στην Κόστα Ρίκα',
    cost_of_rental: 'Κόστος ενοικίασης',
    to_pay_now: 'Πληρωμή τώρα',
    greenheart_donation: 'Δωρεά Green heart',
    total_cost: 'Συνολικό κόστος ενοικίασης',
    tc_agreement: 'Διάβασα και κατάλαβα τους {0}.',
    tc: 'Όροι & Προϋποθέσεις',
    receive_offers: 'Θα ήθελα να λαμβάνω ειδικές προσφορές μέσω email.',
    donate: 'Ναι, θα ήθελα να δωρίσω {amount}',
    pay_now: 'Πληρώστε {amount} τώρα',
    driver_details: 'Στοιχεία οδηγού',
    complete_driver_details: 'Παρακαλώ συμπληρώστε τα στοιχεία του οδηγού.',
    are_you_the_driver: 'Είστε ο οδηγός;',
    have_an_account: 'Έχετε ήδη λογαριασμό;',
    login: 'Σύνδεση',
    or: 'ή',
    first_name: 'Όνομα οδηγού',
    last_name: 'Επώνυμο οδηγού',
    email: 'Διεύθυνση email',
    phone_number: 'Αριθμός κινητού',
    unable_to_save_driver_information: 'Αδυναμία αποθήκευσης στοιχείων οδηγού. Παρακαλώ δοκιμάστε ξανά.',
    pay_online_now: 'Πληρώστε τώρα',
    day: 'Ημέρα',
    choose_location: 'Επιλέξτε τοποθεσία',
    location_not_found: 'Συγγνώμη, δεν βρέθηκε η τοποθεσία που ζητήσατε.',
    add: 'Προσθήκη',
    remove: 'Αφαίρεση',
    free_extra: 'Δωρεάν επιπλέον',
    free: 'ΔΩΡΕΑΝ!',
    fast_track_notice: 'Ισχύουν περιορισμοί προέλευσης εγγράφων για αυτή την υπηρεσία. Διατίθεται μόνο για άτομα με έγγραφα από',
    complete_booking: 'Ολοκλήρωση κράτησης',
    choose_card: 'Παρακαλώ επιλέξτε κάρτα ή προσθέστε νέα.',
    add_billing_details: 'Παρακαλώ προσθέστε στοιχεία χρέωσης.',
    card_number: 'Αριθμός κάρτας',
    card_holder_name: 'Όνομα κατόχου κάρτας',
    card_exp: 'ΜΜ / ΕΕ',
    card_cvc: 'CVC',
    save_card: 'Αποθήκευση κάρτας;',
    amount_charged: 'Η κάρτα σας θα χρεωθεί',
    payment_confirmation: 'Επιβεβαίωση κράτησης και πληρωμή',
    payment_methods: 'διαθέσιμες μέθοδοι πληρωμής',
    use_saved_card: 'x χρήση αποθηκευμένης κάρτας',
    use_different_card: '+ χρήση διαφορετικής κάρτας',
    book_now: 'Κράτηση τώρα',
    minimum_age: 'Μόνο για άνω των {age}',
    excess_liability: 'Απαλλαγή ευθύνης',
    security_deposit: 'Εγγύηση',
    fuel_policy: 'Πολιτική καυσίμων',
    like_for_like: 'Όπως παραλάβατε',
    full_to_full: 'Γεμάτο προς γεμάτο',
    miles_per_rental: '{mileage} δωρεάν μίλια ανά ενοικίαση',
    km_per_rental: '{mileage} δωρεάν χλμ ανά ενοικίαση',
    unlimited_mileage: 'Απεριόριστα μίλια',
    unlimited_mileage_km: 'Απεριόριστα χλμ',
    non_amendable: 'Μη τροποποιήσιμο',
    non_refundable: 'Μη επιστρέψιμο',
    free_cancellation_until: 'Δωρεάν ακύρωση έως',
    cancellation_in_line_with: 'Ακύρωση σύμφωνα με',
    tcs: 'Όροι & Προϋποθέσεις',
    free_extras_on_collection: 'Δύο δωρεάν επιπλέον κατά την παραλαβή',
    glass_and_tyres_covered: 'Κάλυψη γυαλιών και ελαστικών',
    number_of_passengers: 'Αριθμός επιβατών',
    number_of_bags: 'Αριθμός αποσκευών',
    fuel_type: 'Τύπος καυσίμου',
    co2: 'CO2',
    book_type: 'Κράτηση {type}',
    processing: 'Επεξεργασία',
    actual_price: 'Πραγματική τιμή',
    tooltip: 'Η τιμή σε {currencyCode} είναι εκτίμηση βάσει συναλλαγματικής ισοτιμίας, η τιμή σε {currency} είναι δεσμευτική.',
    deposit: 'Κατάθεση',
    pay_online: 'Πληρώστε τώρα',
    pay_online_without_extras: 'Τιμή ενοικίασης',
    extras_on_arrival: 'Επιπλέον κατά την άφιξη',
    insurance_on_arrival: 'Μείωση κινδύνου - Πληρωμή κατά την άφιξη',
    insurance_online: 'Μείωση κινδύνου - Πληρωμή τώρα',
    extras_online: 'Επιπλέον πληρωμή τώρα',
    green_heart_donation: 'Δωρεά Green Heart',
    why_use_drive_and_go: 'Γιατί να χρησιμοποιήσετε το Drive & Go;',
    straight_to_car: 'Κατευθείαν στο αυτοκίνητο',
    no_queues: 'Χωρίς ουρές',
    self_checkout: 'Αυτοεξυπηρέτηση',
    cant_lose_key: 'Δεν μπορείτε να χάσετε το κλειδί',
    online_id_check: 'Διαδικτυακός έλεγχος ταυτότητας',
    phone_as_key: 'Το τηλέφωνο ως κλειδί',
    premiumplus_benefits_includes: 'Περιλαμβάνονται και τα οφέλη Premium Plus+',
    book_drive_go: 'Κράτηση Drive & Go',
    distance_allowance: 'Επιτρεπόμενη απόσταση',
    duration: 'Διάρκεια',
    view_more_bookings: 'Προβολή περισσότερων κρατήσεων',
    to_pay_on_arrival: 'Πληρωμή κατά την άφιξη',
    pay_on_arrival: 'Πληρωμή κατά την άφιξη',
    unlimited: 'Απεριόριστο',
    return_date: 'Ημερομηνία επιστροφής',
    postcode: 'Ταχυδρομικός κώδικας',
    country: 'Χώρα',
    drive_and_go: {
        drive_and_go: 'Drive And Go',
        available_countries: 'Το Drive &amp; Go είναι διαθέσιμο μόνο για άτομα με έγγραφα ταυτότητας και άδειας οδήγησης από τις παρακάτω χώρες:',
        drive_and_go_today: 'Κράτηση Drive & Go σήμερα!',
        drive_and_go_shortened: 'Drive & Go',
        why_use_drive_and_go: 'Γιατί να χρησιμοποιήσετε το Drive & Go;',
        straight_to_car: 'Κατευθείαν στο αυτοκίνητο',
        no_queues: 'Χωρίς ουρές',
        self_checkout: 'Αυτοεξυπηρέτηση',
        cannot_lose_the_key: 'Δεν μπορείτε να χάσετε το κλειδί',
        online_id_check: 'Διαδικτυακός έλεγχος ταυτότητας',
        phone_as_a_key: 'Το τηλέφωνο ως κλειδί',
        premium_plus_benefits_also_included: 'Περιλαμβάνονται και τα οφέλη Premium Plus+',
        book_drive_and_go: 'Κράτηση Drive & Go',
    },
    car_and_camp: {
        tent_and_equipment: 'Σκηνή και εξοπλισμός',
        quick_and_easy: 'Γρήγορη και εύκολη τοποθέτηση',
        travel_freedom: 'Ελευθερία ταξιδιού',
        affordable_campervan_alternative: 'Οικονομική εναλλακτική λύση αντί για αυτοκινούμενο τροχόσπιτο',
        lightweight_and_compact: 'Ελαφρύ και συμπαγές',
        fully_insured: 'Πλήρως ασφαλισμένο',
    },
    my_bookings: 'Οι κρατήσεις μου',
    no_bookings: 'Καμία κράτηση',
    my_profile: 'Το προφίλ μου',
    no_bookings_to_display: 'Δεν υπάρχουν κρατήσεις προς εμφάνιση.',
    search_great_car_rental_deals: 'Αναζητήστε εξαιρετικές προσφορές ενοικίασης αυτοκινήτων για το επόμενο ταξίδι σας.',
    odometer_at_collection: 'Χιλιομετρητής κατά την παραλαβή',
    fuel_at_collection: 'Καύσιμα κατά την παραλαβή',
    start_check_in: 'Έναρξη check-in',
    start_collection: 'Έναρξη παραλαβής',
    recent_bookings: 'Πρόσφατες κρατήσεις',
    damage: {
        updated_damage_report_submitted: 'Υποβλήθηκε ενημερωμένη αναφορά ζημιάς. Ένα μέλος της εξυπηρέτησης πελατών θα επικοινωνήσει μαζί σας αν χρειαστεί.',
        add_additional_damage: 'Προσθήκη επιπλέον ζημιάς',
        you_may_report_additional_damage_up_to: 'Μπορείτε να αναφέρετε επιπλέον ζημιά έως και 24 ώρες μετά την παραλαβή του οχήματος',
        specify_damage: 'Καθορίστε τη ζημιά',
        please_choose_the_area_and_type_of_damage: 'Παρακαλώ επιλέξτε την περιοχή και τον τύπο ζημιάς',
        type_of_damage: 'Τύπος ζημιάς',
        is_this_more_than_5_cm: 'Είναι πάνω από 5εκ;',
        please_take_or_select_a_photo: 'Παρακαλώ τραβήξτε ή επιλέξτε μια φωτογραφία',
        please_take_a_photo_ensuring_the_damage_is_clearly_visible: 'Παρακαλώ τραβήξτε μια φωτογραφία ώστε η ζημιά να φαίνεται καθαρά',
        if_you_require_you_may_add_another_photo_select_the_icon_to_add_another_photo: 'Αν χρειάζεται μπορείτε να προσθέσετε άλλη μια φωτογραφία, επιλέξτε το εικονίδιο για προσθήκη',
        save_image: 'Αποθήκευση εικόνας',
        save_images: 'Αποθήκευση εικόνων',
        damage_saved_successfully: 'Η ζημιά αποθηκεύτηκε με επιτυχία',
        add_photo: 'Προσθήκη φωτογραφίας',
    },
    checkout: {
        start_collection: 'Έναρξη παραλαβής',
        collect_vehicle: 'Παραλαβή οχήματος',
        we_will_let_you_know_the_details: 'Θα σας ενημερώσουμε για την τοποθεσία και τα στοιχεία για να εντοπίσετε το όχημα.',
        inspect: 'Έλεγχος',
        we_will_ask_for_four_photos_from_each_corner: 'Θα ζητήσουμε τέσσερις φωτογραφίες από κάθε γωνία του οχήματος μαζί με τυχόν νέες ζημιές που δεν έχουν καταγραφεί.',
        fuel_and_milage: 'Καύσιμα & Χιλιόμετρα',
        you_confirm_the_readings_at_the_start_of_your_hire: 'Επιβεβαιώνετε τις ενδείξεις χιλιομετρητή και καυσίμων στην αρχή της ενοικίασης.',
        sign: 'Υπογραφή',
        sign_the_rental_agreement: 'Υπογράψτε τη σύμβαση ενοικίασης.',
        away_you_go: 'Καλή διαδρομή',
        you_are_free_to_take_to_the_road: 'Είστε έτοιμοι να ξεκινήσετε!',
        collect_your_vehicle: 'Παραλάβετε το όχημά σας',
        get_directions: 'Λήψη οδηγιών',
        hide_directions: 'Απόκρυψη οδηγιών',
        local_time: 'τοπική ώρα',
        tel: 'Τηλ',
        getting_to_the_location: 'Μετάβαση στην τοποθεσία',
        get_vehicle_details: 'Λήψη στοιχείων οχήματος',
        view_map: 'Προβολή χάρτη',
        unlock_vehicle_and_continue: 'Ξεκλείδωμα οχήματος & συνέχεια',
        unable_to_connect_to_vehicle: 'Αδυναμία σύνδεσης με το όχημα',
        we_were_unable_to_connect_to_the_vehicle_please_check: 'Δεν ήταν δυνατή η σύνδεση με το όχημα - ελέγξτε ότι βρίσκεστε δίπλα στο σωστό όχημα και δοκιμάστε ξανά.',
        we_were_unable_to_find_the_vehicle_booking_please_try_again_later: 'Δεν βρέθηκε η κράτηση του οχήματος. Παρακαλώ δοκιμάστε αργότερα.',
        odometer_and_fuel: 'Χιλιομετρητής & καύσιμα',
        odometer: 'Χιλιομετρητής',
        please_confirm_the_odometer_and_fuel_readings: 'Αν είναι δυνατόν, επιβεβαιώστε τις ενδείξεις χιλιομετρητή και καυσίμων.',
        the_odometer_field_is_required: 'Το πεδίο χιλιομετρητή είναι υποχρεωτικό',
        and_must_be_greater_than_the_checkout_odometer: '& πρέπει να είναι μεγαλύτερο από το χιλιομετρητή κατά την παραλαβή',
        confirm: 'Επιβεβαίωση',
        please_take_a_photo_from_each_corner_of_the_vehicle: 'Παρακαλώ τραβήξτε μια φωτογραφία από κάθε γωνία του οχήματος',
        pre_existing_damage: 'Προϋπάρχουσα ζημιά',
        no_pre_existing_damage: 'Δεν υπάρχουν προϋπάρχουσες ζημιές.',
        new_damage: 'Νέα ζημιά',
        add_additional_damage: 'προσθήκη επιπλέον ζημιάς',
        no_new_damage_to_report: 'Δεν υπάρχουν νέες ζημιές προς αναφορά',
        checkout_complete: 'Ολοκλήρωση παραλαβής',
        start_rental: 'Έναρξη ενοικίασης',
        congratulations_name_it_is_time_to_take_to_the_road: 'Συγχαρητήρια {customer_name}, ήρθε η ώρα να ξεκινήσετε!',
        we_are_unable_to_complete_your_vehicle_checkout: 'Δεν ήταν δυνατή η ολοκλήρωση της παραλαβής του οχήματος.',
        please_do_the_following: 'Παρακαλώ κάντε τα εξής',
        remove_all_belonging_and_lock_the_vehicle: 'Αφαιρέστε όλα τα αντικείμενα και κλειδώστε το όχημα.',
        lock_vehicle: 'Κλείδωμα οχήματος',
        once_you_have_contacted_customer_services: 'Αφού επικοινωνήσετε με την εξυπηρέτηση πελατών',
        vehicle_location: 'Τοποθεσία οχήματος',
        collect_your: 'Παραλάβετε το',
        from: 'Από',
        key_in_glove_box: 'το κλειδί σας βρίσκεται στο ντουλαπάκι',

        keyholder: {
            not_detected: 'Δεν εντοπίστηκε κλειδοθήκη',
            not_detected_please_try_again: 'Τοποθετήστε το κλειδί στην κλειδοθήκη και δοκιμάστε ξανά.',

            not_installed: 'Δεν έχει εγκατασταθεί κλειδοθήκη',
            not_installed_please_contact_customer_service: 'Δεν έχει εγκατασταθεί κλειδοθήκη, επικοινωνήστε με την εξυπηρέτηση πελατών.',
        },
        keyring: {
            look_up_failed: 'Αποτυχία αναζήτησης μπρελόκ',
            look_up_failed_please_contact_customer_service: 'Αποτυχία αναζήτησης μπρελόκ, επικοινωνήστε με την εξυπηρέτηση πελατών.',
        },
        key: {
            invalid: 'Μη έγκυρο κλειδί',
            invalid_please_contact_customer_service: 'Το κλειδί σας δεν είναι έγκυρο, επικοινωνήστε με την εξυπηρέτηση πελατών.',

            expired: 'Το κλειδί έχει λήξει',
            expired__please_contact_customer_service: 'Το κλειδί σας έχει λήξει, επικοινωνήστε με την εξυπηρέτηση πελατών.',
        },
    },
    checkin: {
        start_check_in: 'Έναρξη check-in',
        vehicle_location: 'Τοποθεσία οχήματος',
        tell_us_where_you_have_parked: 'Πείτε μας πού σταθμεύσατε το όχημα.',
        fuel_and_milage: 'Καύσιμα & Χιλιόμετρα',
        you_confirm_the_readings_at_the_end_of_your_hire: 'Επιβεβαιώνετε τις ενδείξεις χιλιομετρητή και καυσίμων στο τέλος της ενοικίασης.',
        inspect: 'Έλεγχος',
        we_will_as_for_four_photos_from_each_corner_of_the_vehicle_along_with_any_new_damage:
            'Θα ζητήσουμε τέσσερις φωτογραφίες από κάθε γωνία του οχήματος μαζί με τυχόν νέες ζημιές κατά τη διάρκεια της ενοικίασης.',
        lock: 'Κλείδωμα',
        check_you_have_left_no_belonging_then_lock_the_vehicle: 'Ελέγξτε ότι δεν έχετε αφήσει αντικείμενα και κλειδώστε το όχημα.',
        please_tell_us_where_you_have_parked_the_vehicle: 'Παρακαλώ πείτε μας πού σταθμεύσατε το όχημα',
        once_the_vehicle_is_locked_you_will_be_unable_to_unlock_it_again: 'Αφού κλειδώσετε το όχημα, δεν θα μπορείτε να το ξεκλειδώσετε ξανά.',
        name_please_check_you_have_left_no_belongings_then_lock_the_vehicle:
            '{first_name}, ελέγξτε ότι δεν έχετε αφήσει αντικείμενα, κλειδώστε το όχημα και αν χρειάζεται επιστρέψτε το φυσικό κλειδί στην κλειδοθήκη.',
        lock_vehicle: 'Κλείδωμα οχήματος',
        complete_check_in: 'Ολοκλήρωση check-in',
        inspection: 'Έλεγχος',
        complete_vehicle_check_in: 'Ολοκλήρωση check-in οχήματος',
        we_are_unable_to_complete_your_vehicle_check_in: 'Δεν ήταν δυνατή η ολοκλήρωση του check-in του οχήματος.',
        please_contact_customer_services: 'Επικοινωνήστε με την εξυπηρέτηση πελατών',
        once_you_have_contacted_customer_services: 'Αφού επικοινωνήσετε με την εξυπηρέτηση πελατών',
        please_amend_odometer_to_be_greater_than: 'Παρακαλώ διορθώστε το χιλιομετρητή να είναι μεγαλύτερος από {odometer_value}',
    },
    rental_agreement: {
        rental_agreement: 'Σύμβαση ενοικίασης',
        agreement_between: 'Συμφωνία μεταξύ',
        and: 'και',
        sign_rental_agreement: 'Υπογράψτε τη σύμβαση ενοικίασης',
        i_have_read_and_understood_the_terms_and_conditions: 'Διάβασα και κατάλαβα τους Όρους & Προϋποθέσεις και αποδέχομαι την κατάσταση του οχήματος',
    },
    additional_options: 'Επιπλέον επιλογές',
    booking_details: 'Στοιχεία κράτησης',
    price_for_x_days: 'Τιμή για {qty_of_days} ημέρα | Τιμή για {qty_of_days} ημέρες',
    cancelled: 'Ακυρώθηκε',
    upcoming: 'Επερχόμενη',
    active: 'Ενεργή',
    full_insurance_no_deposit: 'Πλήρης ασφάλιση & χωρίς εγγύηση',
    excess: '{amount} απαλλαγή',
    deposit: '{amount} εγγύηση',
    included_daily_distance: '{distance} {unit} ανά ημέρα',
    miles: 'μίλια',
    kilometers: 'χιλιόμετρα',
    collection_details_title: 'Στοιχεία παραλαβής',
    collection_details_not_found: 'Δεν έχουν οριστεί στοιχεία παραλαβής για αυτή την τοποθεσία',
    free_cancellation: 'Δωρεάν ακύρωση',
    no_deposit: 'Χωρίς εγγύηση',
    benefit_from: 'Επωφεληθείτε από',
    for_only_per_day: 'Μόνο με {price} ανά ημέρα',
    upgrade_mee: 'ΑναβάθμισηMee',
};
